import { baseApi } from './baseApi';

/**
 * Estado del checklist "Primeros pasos". Todo se calcula en el servidor desde los
 * hechos del tenant (hay productos, hay caja, hay una venta); nada se "marca".
 * Fechas en UTC ISO.
 */
export interface OnboardingStatus {
  productsCount: number;
  firstProductAt?: string | null;
  cashRegistersCount: number;
  firstCashRegisterAt?: string | null;
  salesCount: number;
  firstSaleAt?: string | null;
  tablesCount: number;
  printersCount: number;
  /** Menú cargado y primera venta cobrada. */
  completed: boolean;
  /** Caja abierta A NOMBRE del usuario con sesión: es lo que exige el cobro. */
  hasOpenCashRegister: boolean;
}

export const onboardingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOnboardingStatus: builder.query<OnboardingStatus, void>({
      query: () => '/onboarding/status',
      providesTags: ['Onboarding'],
    }),
  }),
});

export const { useGetOnboardingStatusQuery } = onboardingApi;
